import { getJsonFetchOption } from "@/api/utils";
import { getMoskitoInfo } from "@/moskito-wordpress/utils";

import exampleResponse from "./exampleResponse.json";
import exampleMobileResponse from "./exampleMobileResponse.json";

const apiBaseUrl = "https://moskito-pagespeed-api.azurewebsites.net/api";

export const getPagespeedReportForUrl = async (url, reportOptions) => {
  const moskitoInfo = getMoskitoInfo();
  const requestUrl = `${apiBaseUrl}/getpagespeedreport?pageUrl=${encodeURIComponent(
    url,
  )}&strategy=${reportOptions.strategy}&website_id=${moskitoInfo.website_id}`;
  if (
    window.location.href.includes("localhost") ||
    window.location.href.includes("netlify.app")
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data:
            reportOptions.strategy === "desktop"
              ? exampleResponse
              : exampleMobileResponse,
        });
      }, 888);
    });
  }
  const headers = {
    Accept: "application/json",
  };

  const { data, error } = await getJsonFetchOption(
    fetch(requestUrl, {
      headers,
    }),
  );
  if (error) {
    return { error };
  }
  if (data.error) {
    // Request to Moskito API ok, but Google Pagespeed API might have some problems.
    return { error: data.error };
  }
  return { data };
};
